module.exports = __webpack_public_path__ + "img/benefit_playoff-fan-central.7b727d8d.jpg";